module.exports = __webpack_public_path__ + "img/business-transformation.a558a74f.png";